(function (app) {
    app.provider("tokenApi", [function () {
        this.$get = ["crmApiGateway", function (crmApiGateway) {
            var service = {};

            service.get = function(code) {
                return crmApiGateway.get("/Login/" + code);
            };

            return service;
        }];
    }]);
})(window.app);